import {
  GET_PROVIDER_SALON_LIST,
  GET_PROVIDER_SALON_LIST_FAILURE,
  GET_PROVIDER_SALON_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getProviderSalonListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVIDER_SALON_LIST:
      return { ...state, loading: true };
    case GET_PROVIDER_SALON_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_PROVIDER_SALON_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getProviderSalonListReducer;
